import React from 'react';
import { GiftIcon } from 'lucide-react';
import { AccordionItem } from './Accordion';
import { BONUSES } from '../data/content';
import { scrollToOffer } from './BuyButton';
export function Bonuses() {
  return <section className="px-5 py-8" data-id="element-27">
      <div className="mx-auto max-w-xl" data-id="element-28">
        <p className="mx-auto max-w-lg rounded-2xl border border-white/20 bg-[#101b2d]/95 p-5 text-center font-display text-xl font-800 uppercase leading-tight text-white shadow-lg shadow-black/20" data-id="element-29">
          We want you to truly succeed with this, which is why your purchase
          includes:
        </p>

        <div className="mt-4 flex items-center justify-center gap-2 rounded-full border border-[var(--pb-lime)]/40 bg-[#16263b]/95 px-4 py-2 text-center shadow-lg shadow-black/20" data-id="element-30">
          <GiftIcon size={16} className="text-[var(--pb-lime)]" data-id="element-31" />
          <span className="text-sm font-700 text-[var(--pb-lime)]" data-id="element-32">
            6 FREE bonuses — today only
          </span>
        </div>

        <div className="mt-6 space-y-3" data-id="element-33">
          {BONUSES.map((b, i) => <AccordionItem key={b.title} emoji={b.emoji} title={`${i + 1}. ${b.title}`} badge={b.format} defaultOpen={i === 0} data-id="element-34">
              {b.image && <button type="button" onClick={scrollToOffer} aria-label={`View the offer — ${b.title} bonus`} className="mb-3 block w-full" data-id="element-35">
                  <img src={b.image} alt={`${b.title} (${b.format}) — included bonus`} className="w-full rounded-xl ring-1 ring-white/20" data-id="element-36" />
                </button>}
              <p className="text-sm leading-relaxed text-white/80" data-id="element-37">{b.body}</p>
            </AccordionItem>)}
        </div>
      </div>
    </section>;
}